import React from 'react'

import { Form, Col, AsyncSelect } from '_zari/core'

import { ClearInputGroup } from 'sharedComponents/utils'

import * as ProductoService from 'services/producto.service'

const ProductoFormGroup = ({ iValue, fIsSubmitting, setFieldValue }) => {
  const loadProductosSelect = React.useCallback((inputValue, resolve) => {
    ProductoService.obtenerAsSelect2Presupuesto({ busqueda: inputValue || '' })
      .then(({ data }) => resolve(data))
      .catch(() => resolve([]))
  }, [])

  const onChangeProducto = React.useCallback(
    producto => {
      if (!producto || !producto.value) return

      ProductoService.getProducto_Ventas(producto.value).then(({ data }) => {
        const productoInfo = `${data.codigoProducto || ''} - ${data.nombreProducto || ''}`.trim()
        setFieldValue('_idProducto', data._idProducto || '')
        setFieldValue('_idProductoPresentacion', producto.value)
        setFieldValue('productoInfo', productoInfo)
        setFieldValue('modelo', data.modelo || '')
        setFieldValue('_idCategoria', data._idCategoria || '')
        setFieldValue('categoria', data.categoria || '')
        setFieldValue('_idFamilia', data._idFamilia || '')
        setFieldValue('familia', data.familia || '')
        setFieldValue('_idSubFamilia', data._idSubFamilia || '')
        setFieldValue('subFamilia', data.subFamilia || '')
      })
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('_idProducto', '')
    setFieldValue('_idProductoPresentacion', '')
    setFieldValue('productoInfo', '')
    setFieldValue('modelo', '')
    setFieldValue('_idCategoria', '')
    setFieldValue('categoria', '')
    setFieldValue('_idFamilia', '')
    setFieldValue('familia', '')
    setFieldValue('_idSubFamilia', '')
    setFieldValue('subFamilia', '')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='PRODUCTO' htmlFor='select-producto-activo-fijo' md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='producto-activo-fijo' iValue={iValue} clickClear={clickClear} />
        ) : (
          <AsyncSelect
            selectId='select-producto-activo-fijo'
            loadOptions={loadProductosSelect}
            onChange={onChangeProducto}
            isDisabled={fIsSubmitting}
          />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProductoFormGroup)
